import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import { TeamMemberActionConfigContext } from '../../context/team-member-action-config';
import { config } from './config';
import { currentPlanConfig } from './currentPlanConfig';
import * as Styled from './styles';
import type { TeamMemberTableProps as Props } from './types';

export const TeamMemberTable = memo(({ className, inCurrentPlan }: Props) => {
  const stableConfig = useMemo(
    () => (inCurrentPlan ? currentPlanConfig : config),
    [inCurrentPlan]
  );

  return (
    <TeamMemberActionConfigContext.Provider value={{ inCurrentPlan }}>
      <Styled.Wrapper
        className={classnames('TeamMemberTable', className)}
        config={stableConfig}
      />
    </TeamMemberActionConfigContext.Provider>
  );
});

TeamMemberTable.displayName = 'TeamMemberTable';
